module.exports = __webpack_public_path__ + "img/Bank Resona Perdania.33159156.png";